// extracted by mini-css-extract-plugin
module.exports = {"h1":"H1-module--h1--20_X8"};